import React, { useState } from 'react';
import Popup from './Popup';
import './css/typography.css';
import './css/ExperienceSection.css';
import './css/layout.css';

// Importation des fichiers audio
import ventPoeme from './music/vent_poeme.mp3';
import fatherSon from './music/Father_.mp3';
import wishYouWereHere from './music/Wish_.mp3';
import putItThere from './music/Put_.mp3';
import Ballade from './music/Ballade.mp3';
import colours from './music/colours.mp3';
import planes from './music/planes.mp3';
import raya from './music/raya.mp3';
import summertime from './music/summertime.mp3';



const ExperienceColumn = ({ title, isOpen, toggleOpen, items, handleContentClick }) => (
  <div className="experience-column">
    <h2 onClick={toggleOpen} className="dropdown-title">
      {title}
    </h2>
    <div className={`dropdown-content ${isOpen ? 'open' : ''}`}>
      {items.map((item, index) => (
        <p
          key={index}
          className={item.type ? "clickable" : ""}
          onClick={item.type ? () => handleContentClick(item) : null}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <span>{item.title}</span>
          {item.tag && <span className="experience-tag">{item.tag}</span>}
        </p>
      ))}
    </div>
  </div>
);

const ExperienceSection = () => {
  const [selectedContent, setSelectedContent] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleContentClick = (content) => {
    setSelectedContent(content);
  };

  const closePopup = () => {
    setSelectedContent(null);
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const studioItems = [
    { type: 'audio', title: "Summertime - Louise", audioPath: summertime, text: "Enregistrement - Mixage"  },
    { type: 'audio', title: "Je n’ai pas peur du vent", audioPath: ventPoeme, text: "Enregistrement voix" },
    { type: 'audio', title: "Father & Son - Serge Vilamajo", audioPath: fatherSon, text: "Mastering" },
    { type: 'audio', title: "Wish You Were Here (cover) - Serge Vilamajo", audioPath: wishYouWereHere, text: "Mastering" },
    { type: 'audio', title: "Put it There (cover) - Serge Vilamajo", audioPath: putItThere, text: "Mastering" },
    { type: 'audio', title: "Ballade Blues - Quentin Gouraud", audioPath: Ballade, text: "Enregistrement - Mixage" },
    { type: 'audio', title: "Colours in the Sky - Louise", audioPath: colours, text: "Enregistrement - Mixage" },
    { type: 'audio', title: "Raya - Casper Sanderson",  audioPath: raya, text: "Mixage"  },
    { type: 'audio', title: "Planes - Casper Sanderson",  audioPath: planes, text: "Mixage"  },
  ];

  const audiovisuelItems = [   

    { type: 'video', title: "Entre nous le vide", videoUrl: "https://www.youtube.com/embed/d8qwLMKs8Mk", imagePath: "/image/entre.webp", text: "Opérateur son - Mixeur \n Réalisateur: Jérémie Antocicco ", tag: "Court Nikon" },
    { type: 'video', title: "Ce qu'il reste", videoUrl: "https://www.youtube.com/embed/ci-HmQKcTM0", imagePath: "/image/reste.webp", text: "Opérateur son - Mixeur \n Réalisateur: Camille BONSERGENT / Nicolas BONSERGENT ", tag: "Court Nikon" },
    { type: 'video', title: "Happy Reset", videoUrl: "https://www.youtube.com/embed/9X1EGjUUc9A", imagePath: "/image/happy.webp", text: "Opérateur son \n Réalisateur: Bruce Blérald ", tag: "Série Fiction" },
    { type: 'image', title: "La Firme Phocéennes", imagePath: "/image/firme.webp", link: "https://www.instagram.com/lafirme.co/?hl=en", text: "Opérateur Son \nLa Firme Production ", tag: "Doc" },
    { type: 'video', title: "Tonito", videoUrl: "https://www.youtube.com/embed/5ca0hvZsuhg", text: "Clip Musical // Fiction \n Opérateur Son \nRéalisation: Philippe Car\n Scénario et Composition: Anais Delmas ", tag: "Court" },
    { type: 'image', title: "Thérèse", imagePath: "/image/therese.webp", text: "Opérateur Son \nRéalisation: Jérémie Antocicco \n EN PRODUCTION\n ", link: "https://www.jeremieantocicco.com/film", tag: "Court" },
    { type: 'image', title: "Between Two Shores", imagePath: "/image/algerian.webp", text: "Documentaire sur la diaspora algérienne \nOpérateur Son \nRéalisation: Algerian Connect \n EN PRODUCTION\n ", link: "https://www.instagram.com/algerianconnect?igsh=ZHJxZTYxOW9qdWZh&utm_source=qr", tag: "Doc" },
    { type: 'image', title: "Les Retombées", imagePath: "/image/glouglou.webp", text: "Opérateur Son \nGlouGlou Production \nRéalisation: Lounseny Soumah \n EN POST-PRODUCTION\n ", link: "https://www.instagram.com/_glouglou_/?hl=en", tag: "Court" },
    { type: 'image', title: "ZXlandjump360", imagePath: "/image/ZX.webp", text: "Opérateur Son \nLa Firme Production ", link: "https://www.instagram.com/p/DN57gEfCKyh/", tag: "Pub" },
    { type: 'image', title: "Postcard From Marseille", imagePath: "/image/postcard.webp", text: "Opérateur Son \nRéalisatrices: Hermance Roué et Marie Abega\n Production: Channel Rose ", link: "https://vimeo.com/1138069291/cc9acb9e2e?fl=pl&fe=sh", tag: "Court" },
    { type: 'image', title: "Bête de Somme", imagePath: "/image/bete.webp", text: "Opérateur Son \nRéalisateur: Pierre Millet-Bellando \nEN POST-PRODUCTION ", link: "https://www.instagram.com/p/DRhjMAjClfa/", tag: "Court" },
    { type: 'image', title: "Jeunesse en éveil", imagePath: "/image/green-prod.webp", text: "Opérateur Son \nProduction Green Prod \nEN PRODUCTION", link: "https://green-prod.fr/projet-jeunesse-en-eveil/", tag: "Doc" },
    { type: 'image', title: "France 2 Télématin - La Reine du Poulpe", imagePath: "/image/poulpe.webp", text: "Opérateur Son \nProduction Novo Corp.", link: "https://www.facebook.com/watch?v=1319604929159056", tag: "TV" },
    { type: 'image', title: "Bienvenue à Saint-Ailettes - Arno Polvent", imagePath: "/image/poulet.png", text: "Court-métrage de Fiction \n1e Assistant \nTentacules Production", link: "https://www.youtube.com/watch?v=tje1lRN7P1A&t=79s&ab_channel=ArnoPolvent", tag: "Court" }, 
    { type: 'image', title: "Julia Florida", imagePath: "/image/barrios.webp", text: "Julia Florida de Barrios \nEnregistrement, Réalisation", link: "https://www.instagram.com/reel/DE75zW_O1XP/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA==", tag: "Clip" },
    { type: 'image', title: "An other night in Marseille", imagePath: "/image/jazz.webp", text: "Amadis De Gaula (voix et compo) \nMoi à la réalisation et à l'enregistrement, mixage", link: "https://www.instagram.com/p/DD9PviAAvME/", tag: "Clip" },
    { type: 'image', title: "Les Baigneuses - Anouk Barrère", imagePath: "/image/baigneuses.png", text: "Prise de Son, ambiances post-production", link: "https://fr.ulule.com/les-baigneuses/", tag: "Court"  },
    { type: 'video', title: "Capsule Sonore #07", videoUrl: "https://www.youtube.com/embed/t1gJC48gZIw", text: "Court-Métrage d'animation onirique \nComposition musicale et sonore \nréalisation: Thomas Csaba", tag: "Court" },
    { type: 'video', title: "Capsule Sonore #08", videoUrl: "https://www.youtube.com/embed/U_fn_FYRYgo", text: "Court-Métrage d'animation onirique \nComposition musicale et sonore \nRéalisation: Thomas Csaba", tag: "Court" },
    { type: 'video', title: "Capsule Sonore #09", videoUrl: "https://www.youtube.com/embed/DQmVTXxFgew", text: "Court-Métrage d'animation onirique \nComposition musicale et sonore \n Réalisation: Thomas Csaba", tag: "Court" },
    { type: 'video', title: "9-4", videoUrl: "https://www.youtube.com/embed/nlMcYo7ZPo0", text: "Enregistrement live multi-piste", tag: "Clip" },
    { type: 'video', title: "American Boy", videoUrl: "https://www.youtube.com/embed/cKrbWY7-VMo", text: "Enregistrement studio clip", tag: "Clip" },
    { type: 'video', title: "My Lord Willoughby's Welcome Home", videoUrl: "https://www.youtube.com/embed/mbmWeG5VP04", text: "Enregistrement studio clip", tag: "Clip" },
    { type: 'video', title: "Canciones Populares", videoUrl: "https://www.youtube.com/embed/hoWQ3mQngPI", text: "Enregistrement studio live", tag: "Clip" },
    { type: 'video', title: "Arvö Pärt, Für Alina & Fratres", videoUrl: "https://www.youtube.com/embed/duiRN06cBSY", text: "Enregistrement studio live", tag: "Clip" },
    { type: 'video', title: "Kiua", videoUrl: "https://www.youtube.com/embed/Ny5bM-HCzAM", text: "Composition et enregistrement studio clip", tag: "Court" },
    { type: 'video', title: "Publicité Bourses Zellidja", videoUrl: "https://www.youtube.com/embed/NGlD_3wq7Nw", text: "Enregistrement Musique et Mixage", tag: "Pub" },
    { type: 'image', title: "En Maria - Alice de Lencquesaing", imagePath: "/image/maria.png", text: "Enregistrement de bruitages et de voix post-synchro",link: "https://lesfilmsdelautrecougar.com/2018/04/13/en-maria/", tag: "Court" },

  ];
  const SpectacleItems = [


        {
      type: 'image',
      title: "Aide à Dom - Groupe MM",
      imagePath: "/image/spectacle/insolation.webp",
      text: "Ingénieur Son et régisseur plateau",
      link: "https://www.youtube.com/watch?v=0OvLWSF8854"
    }, 
    {
      type: 'image',
      title: "Insolation - Groupe MM",
      imagePath: "/image/spectacle/insolation.webp",
      text: "Ingénieur Son et régisseur plateau",
      link: "https://groupe-mm.fr/projets/insolations/"
    }, 
    {
      type: 'image',
      title: "Le Caveau des Oubliettes (Paris)",
      imagePath: "/image/spectacle/caveau2.webp",
      text: "Ingénieur Son - Régisseur"
    },
    {
      type: 'image',
      title: "Les Amarres (Paris)",
      imagePath: "/image/spectacle/amarre3.webp",
      text: "Ingénieur Son - Régisseur"
    },
    {
      type: 'image',
      title: "Le Cabaret Gandaia (Paris)",
      imagePath: "/image/spectacle/gandaia2.webp",
      text: "Ingénieur du Son Itinérant"
    },
    {
      type: 'image',
      title: "La Péniche Antipode (Paris)",
      imagePath: "/image/spectacle/peniche1.webp",
      text: "Ingénieur du Son"
    },
    {
      type: 'image',
      title: "Salle Gérard Philipe (Sainte Genevieve Des Bois)",
      imagePath: "/image/spectacle/philipe1.webp",
      text: "Ingénieur du Son"
    },
    // Ajoutez d'autres items selon vos besoins
  ];

  // Pour les items de type vidéo, ajoutez un imagePath basé sur l'ID YouTube
  const getYouTubeThumbnail = (url) => {
    const videoId = url.split('/').pop();
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };

  return (
    <div className="scroll-section" id="experience">
      
      {/* Section Audiovisuelle en grille */}
      <h2 className="section-subtitle">Audiovisuel</h2>
      <div className="audiovisual-grid">
        {audiovisuelItems.map((item, index) => (
          <div 
            key={index} 
            className="grid-item" 
            onClick={() => handleContentClick(item)}
          >
            <img 
              src={item.imagePath || (item.type === 'video' ? getYouTubeThumbnail(item.videoUrl) : item.imagePath)} 
              alt={item.title} 
              className="grid-image"
            />
            {item.tag && <span className="experience-tag" data-tag={item.tag}>{item.tag}</span>}
          </div>
        ))}
      </div>

      {/* Autres sections dépliables */}
      <div className="experience-section">
        <ExperienceColumn
          title="Studio"
          isOpen={openDropdown === 'studio'}
          toggleOpen={() => toggleDropdown('studio')}
          items={studioItems}
          handleContentClick={handleContentClick}
        />
        <ExperienceColumn
          title="Spectacle"
          isOpen={openDropdown === 'Spectacle'}
          toggleOpen={() => toggleDropdown('Spectacle')}
          items={SpectacleItems}
          handleContentClick={handleContentClick}
        />
      </div>

      {/* Popup existant */}
      {selectedContent && (
        <Popup
          content={
            selectedContent.type === 'audio' ? (
              <>
                <h3 className="h3">{selectedContent.title}</h3>
                <audio controls autoPlay>
                  <source src={selectedContent.audioPath} type="audio/mpeg" />
                  Votre navigateur ne prend pas en charge l'audio.
                </audio>
                {selectedContent.text && <p className="text-small">{selectedContent.text}</p>}
              </>
            ) : selectedContent.type === 'video' ? (
              <>
                <h3 className="h3">{selectedContent.title}</h3>
                <iframe
                  className="video-frame"
                  src={selectedContent.videoUrl}
                  title={selectedContent.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                {selectedContent.text && <p className="text-small">{selectedContent.text}</p>}
              </>
            ) : selectedContent.type === 'image' ? (
              <>
                <h3 className="h3">{selectedContent.title}</h3>
                {selectedContent.link ? (
                  <a href={selectedContent.link} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", cursor: "pointer" }}>
                    <img
                      src={selectedContent.imagePath}
                      alt={selectedContent.title}
                      className="popup-image"
                      style={{ cursor: "pointer" }}
                    />
                  </a>
                ) : (
                  <img
                    src={selectedContent.imagePath}
                    alt={selectedContent.title}
                    className="popup-image"
                  />
                )}
                {selectedContent.text && <p className="text-small">{selectedContent.text}</p>}
              </>
            ) : null
          }
          closePopup={closePopup}
        />
      )}
    </div>
  );
};

export default ExperienceSection;